import React from 'react';
import { Route } from 'react-router-dom';
import { XrystalUnauthenticatedLayout } from './XrystalUnauthenticatedLayout';

export const XrystalUnauthenticatedLayoutRoute = ({ component: Component, showSignIn = true, ...rest }) => {
  return (
    <Route
      {...rest}
      render={(props) => (
        <XrystalUnauthenticatedLayout showSignIn={showSignIn}>
          <Component {...props} />
        </XrystalUnauthenticatedLayout>
      )}
    />
  );
};
